import { useAtomValue } from 'jotai'

import { scoredDataAtom } from '@atoms/scoredDataAtom'

import useAppQueryState from './useAppQueryState'

const useRequestedLoanDetails = () => {
    const { appQueryState } = useAppQueryState()
    const scoredData = useAtomValue(scoredDataAtom)

    return {
        scoreId: scoredData?.scoreId ?? appQueryState.scoreId,
        loanAmount: scoredData?.loanAmount ?? appQueryState.loanAmount,
        loanTerm: scoredData?.loanTerm ?? appQueryState.loanTerm,
    }
}

export default useRequestedLoanDetails
